const sliderImage = [
    {
        id:"1",
        image:require("../../assets/images/slider-1.svg").default
    },
    {
        id:"2",
        image:require("../../assets/images/slider-2.svg").default
    },
    {
        id:"3",
        image:require("../../assets/images/slider-3.svg").default
    },
]

export default sliderImage;